import React from 'react'
import PaymentView from '../PaymentView'
import Footer from '../Footer'
import { STEPS } from '../useReservation'
import { useReservationContext } from '../ReservationContext'

const RecoveryView = () => {
    const {
        offer,
        paymentMethod,
        reservationLoading,
        recoveryPrice,
        t,
    } = useReservationContext()

    return (
        <div className="trip-reservation__right">
            <section className="trip-reservation__section">
                <h1>{t('recovery.title')}</h1>

                <p>{t('recovery.readOnly')}</p>
                <p>{t('recovery.currentExtras')}</p>

                {recoveryPrice && recoveryPrice.changed && (
                    <div
                        className="trip-reservation__error-announcement"
                        role="status"
                    >
                        {t('recovery.priceChanged', {
                            original: recoveryPrice.original.toFixed(2),
                            current: recoveryPrice.current.toFixed(2),
                            currency: recoveryPrice.currency,
                        })}
                    </div>
                )}
            </section>

            <hr className="trip-reservation__divider" />

            <PaymentView
                readOnlyChoices
                allowPromotionChanges
            />

            <Footer
                headingText={t('all-set')}
                subheaderText={t('pay-selected-method')}
                offer={offer}
                reservationLoading={reservationLoading}
                paymentMethod={paymentMethod}
                currentStep={STEPS.PAYMENT}
            />
        </div>
    )
}

export default RecoveryView
